import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=2c97c97f&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=2c97c97f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97c97f",
  null
  
)

export default component.exports